import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {ChecklistType, OrderReviewChecklist} from "../../../../store/state/order-review-checklist.state";
import {EndpointsProvider} from "../../../endpoints/endpoint-provider.service";

@Injectable()
export class ReviewChecklistResolver implements Resolve<OrderReviewChecklist> {

	constructor(private endpoints: EndpointsProvider) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OrderReviewChecklist> {
		const correlationId: string = route.paramMap.get('orderCorrelationId');
		const checklistType: string = route.paramMap.get('checklistType');

		if (checklistType == ChecklistType.APPLICATION_REVIEW) {
			return this.endpoints.review.getChecklist(correlationId);
		}

		return null;
	}
}
